import styled from 'styled-components/macro';
import { getBreakpoint, getSpacing, pxToRem } from '../../utils';
import Tokens from '../../Tokens/tokens';

const { colors } = Tokens;

export const BreadcrumbContainer = styled.nav`
    display: flex;
    align-items: baseline;
    a {
        font-size: ${pxToRem(14)};
        text-decoration: underline;
        display: inline-block;
        color: ${colors.breadcrumb.link};
    }
    svg {
        height: ${pxToRem(8)};
        width: ${pxToRem(8)};
        margin-right: ${getSpacing([6])};
        &:first-child {
            ${getBreakpoint.sm`
                display: none;
            `}
        }
    }
`;

export const BreadcrumbList = styled.ol`
    margin: 0;
    padding-left: 0;
    list-style: none;
    display: inline;
`;

export const BreadcrumbListItem = styled.li`
    display: none;
    padding-left: 0;
    &:nth-last-child(2) {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    ${getBreakpoint.sm`
        display: inline-flex;
        align-items: center;
    `}
    ${getBreakpoint.sm`
        &:last-child {
            a {
                text-decoration: none;
            }
        }
    `}
    svg {
        display: none;
        ${getBreakpoint.sm`
            display: inline;
            margin-left: ${getSpacing([6])};
        `}
    }
`;
